import React from 'react';
import { Trans, t } from '@lingui/macro';
import { AppNotificationBar } from 'components/AppNotificationBar';
import { CONFIG } from 'utils/config';
import { useExecutionEnvironmentContext } from 'contexts/ExecutionEnvironmentContext/ExecutionEnvironmentContext';

interface UsePoorStandingBanner {
    goToAccountBilling: () => void;
}

export const usePoorStandingBanner = ({
    isDAWPlugin,
}: {
    isDAWPlugin: boolean;
}): UsePoorStandingBanner => {
    const goToAccountBilling = () => {
        const target = isDAWPlugin ? '_blank' : '_self';

        window.open(`${CONFIG.VITE_ACCOUNT_BILLING_URL}`, target);
    };

    return { goToAccountBilling };
};

const PoorStandingBanner = () => {
    const { isDAWPlugin } = useExecutionEnvironmentContext();
    const { goToAccountBilling } = usePoorStandingBanner({ isDAWPlugin });

    return (
        <AppNotificationBar
            variant="error"
            action={{
                children: t`Retry payment`,
                onClick: goToAccountBilling,
            }}
        >
            <Trans>There was a problem billing your account.</Trans>
        </AppNotificationBar>
    );
};

export default PoorStandingBanner;
